// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3PjRF","noInteraction":"EventWrapper_noInteraction__3T3Fx","pointerPassthrough":"EventWrapper_pointerPassthrough__2i2Br"};